// extracted by mini-css-extract-plugin
module.exports = {"social_media":"style_social_media__wqSKo","social_media__link":"style_social_media__link__1Z5AB","social_media__icon":"style_social_media__icon__D_Kzz"};